export var ICurrentPromotionalEventResponse;
(function (ICurrentPromotionalEventResponse) {
    let IPromotionalEvent;
    (function (IPromotionalEvent) {
        let IStyle;
        (function (IStyle) {
            /**
             * Return an instance of IStyle with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IStyle.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IStyle = IPromotionalEvent.IStyle || (IPromotionalEvent.IStyle = {}));
        let IMobileImages;
        (function (IMobileImages) {
            /**
             * Return an instance of IMobileImages with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IMobileImages.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IMobileImages = IPromotionalEvent.IMobileImages || (IPromotionalEvent.IMobileImages = {}));
        /**
         * Grouping labels for individual promotional events to their parent events
         */
        let PromotionalEventGroup;
        (function (PromotionalEventGroup) {
            PromotionalEventGroup["PROMOTIONAL_EVENT_GROUP_UNKNOWN"] = "PROMOTIONAL_EVENT_GROUP_UNKNOWN";
            PromotionalEventGroup["MARKET"] = "MARKET";
            PromotionalEventGroup["FASHION_WEEK"] = "FASHION_WEEK";
        })(PromotionalEventGroup = IPromotionalEvent.PromotionalEventGroup || (IPromotionalEvent.PromotionalEventGroup = {}));
        /**
         * Return an instance of IPromotionalEvent with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IPromotionalEvent.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IPromotionalEvent = ICurrentPromotionalEventResponse.IPromotionalEvent || (ICurrentPromotionalEventResponse.IPromotionalEvent = {}));
    /**
     * Return an instance of ICurrentPromotionalEventResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ICurrentPromotionalEventResponse.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(ICurrentPromotionalEventResponse || (ICurrentPromotionalEventResponse = {}));
